import React from "react";
import style from "./style.module.css";

export const SaturationPointer = () => (
  <div className={style.saturationPointer} />
);

export default SaturationPointer;
